import styles from './index.module.scss';

const SocialIcon = ({children,href})=>{
   return(
      <a href={href} target="_blank" className={styles['social-icon']}>
           {children}
      </a>
   )
}
export default SocialIcon